"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatBlock = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _theme = require("../theme");
var _styles = require("./styles");
var _useWindowDimensionsHook = _interopRequireDefault(require("../CustomHooks/useWindowDimensionsHook"));
/**
 * Stat block shared component.
 * @param {Object} props - React props
 */
var StatBlock = function StatBlock(_ref) {
  var className = _ref.className,
    color = _ref.color,
    icon = _ref.icon,
    stat = _ref.stat,
    subtitle = _ref.subtitle,
    suffix = _ref.suffix,
    title = _ref.title,
    children = _ref.children;
  var _useWindowDimensions = (0, _useWindowDimensionsHook["default"])(),
    width = _useWindowDimensions.width;
  var styleColor = color || 'inherit';
  var styledChildren = children;
  if (typeof children === 'string') {
    styledChildren = /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(className, " children")
    }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      className: className,
      variant: width < _theme.breakpointNumbers.lg ? 'h5' : 'h4',
      component: "span",
      style: {
        color: styleColor
      }
    }, children), suffix && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      className: className,
      variant: "overline",
      style: {
        color: styleColor
      }
    }, suffix));
  }
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: className
  }, styledChildren, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " title")
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: className,
    variant: "overline"
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: className,
    variant: "overline"
  }, icon, stat)), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: className,
    variant: "caption"
  }, subtitle));
};
exports.StatBlock = StatBlock;